import React from "react";
import PropTypes from "prop-types";
import { InputLabel, Typography } from "@mui/material";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import textAreaStyles from "./EMPTextAreaField.module.scss";

const EMPTextAreaField = ({
  placeholder,
  required,
  maxCharacters,
  disabled,
  label,
  labelSx,
  characterCounterSx,
  hasCharacterCount,
  testId,
  onChange,
  minRows,
  value,
}) => {
  const characterCount = value?.length || 0;
  const hasReachedCharacterLimit = characterCount === maxCharacters;

  const handleChange = (event) => {
    onChange?.(event);
  };

  return (
    <>
      <InputLabel
        disableAnimation
        shrink={false}
        required={required}
        sx={{
          mb: 1,
          ...labelSx,
        }}
      >
        {label}
      </InputLabel>

      <TextareaAutosize
        className={textAreaStyles.empTextArea}
        value={value}
        minRows={minRows}
        maxRows={4}
        placeholder={placeholder}
        required={required}
        maxLength={hasCharacterCount ? maxCharacters : undefined}
        onChange={handleChange}
        disabled={disabled}
        data-testid={testId}
      />

      {hasCharacterCount && (
        <Typography
          sx={{
            ...characterCounterSx,
            ...(hasReachedCharacterLimit
              ? {
                  color: "error.main",
                }
              : {}),
          }}
        >
          {`${characterCount}/${maxCharacters} characters`}
        </Typography>
      )}
    </>
  );
};

EMPTextAreaField.propTypes = {
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  maxCharacters: PropTypes.number,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelSx: PropTypes.object,
  characterCounterSx: PropTypes.object,
  hasCharacterCount: PropTypes.bool,
  testId: PropTypes.string,
  onChange: PropTypes.func,
  minRows: PropTypes.number,
  value: PropTypes.string,
};

EMPTextAreaField.defaultProps = {
  placeholder: "",
  required: false,
  maxCharacters: 0,
  disabled: false,
  label: "",
  labelSx: {},
  characterCounterSx: {},
  hasCharacterCount: false,
  testId: undefined,
  onChange: undefined,
  minRows: 1,
  value: "",
};

export default EMPTextAreaField;
